import { useCallback } from 'react'
import { useNoteFiltersStore } from '../store/filtersStore'

const usePDNFiltersHook = () => {
    const filters = useNoteFiltersStore(
        ({ users, noteTypes, dateFrom, dateTo }) => ({
            users,
            noteTypes,
            dateFrom,
            dateTo,
        })
    )
    const setNotesFilters = useNoteFiltersStore(
        (state) => state.setNotesFilters
    )

    const setNoteTypes = useNoteFiltersStore((state) => state.setNoteTypes)

    const resetFilters = useNoteFiltersStore((state) => state.resetFilters)

    const clearFilters = useCallback(() => {
        resetFilters()
    }, [resetFilters])

    return { filters, clearFilters, setNotesFilters, setNoteTypes }
}

export default usePDNFiltersHook
